import { render } from "./TestCreateForm.vue?vue&type=template&id=32fbca05&scoped=true"
import script from "./TestCreateForm.vue?vue&type=script&lang=js"
export * from "./TestCreateForm.vue?vue&type=script&lang=js"

import "./TestCreateForm.vue?vue&type=style&index=0&id=32fbca05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fbca05"]])

export default __exports__